import Button from './Button'
import Modal from './Modal'

export * from './vbox'

const VBOX = {
  Button,
  Modal,
}

export default VBOX
